import * as _ from 'lodash-es';
import React from 'react';
import apiIcon from '../icons/non-prefilled/16x16/api.svg';
import airtable from '../icons/prefilled/brands/airtable.svg';
import asana from '../icons/prefilled/brands/asana.svg';
import atlassian from '../icons/prefilled/brands/atlassian.svg';
import bamboohr from '../icons/prefilled/brands/bamboohr.svg';
import box from '../icons/prefilled/brands/box.svg';
import canva from '../icons/prefilled/brands/canva.svg';
import clickup from '../icons/prefilled/brands/clickup.svg';
import coda from '../icons/prefilled/brands/coda.svg';
import codepen from '../icons/prefilled/brands/codepen.svg';
import codepenDark from '../icons/prefilled/brands/codepenDark.svg';
import confluence from '../icons/prefilled/brands/confluence.svg';
import drawio from '../icons/prefilled/brands/drawio.svg';
import drive from '../icons/prefilled/brands/drive.svg';
import dropbox from '../icons/prefilled/brands/dropbox.svg';
import figma from '../icons/prefilled/brands/figma.svg';
import freshdesk from '../icons/prefilled/brands/freshdesk.svg';
import github from '../icons/prefilled/brands/github.svg';
import githubDark from '../icons/prefilled/brands/githubDark.svg';
import gitlab from '../icons/prefilled/brands/gitlab.svg';
import gliffy from '../icons/prefilled/brands/gliffy.svg';
import gliffyDark from '../icons/prefilled/brands/gliffyDark.svg';
import gmail from '../icons/prefilled/brands/gmail.svg';
import google from '../icons/prefilled/brands/google.svg';
import calendar from '../icons/prefilled/brands/googleCalendar.svg';
import doc from '../icons/prefilled/brands/googleDocs.svg';
import drawing from '../icons/prefilled/brands/googleDrawings.svg';
import form from '../icons/prefilled/brands/googleForms.svg';
import map from '../icons/prefilled/brands/googleMaps.svg';
import sheet from '../icons/prefilled/brands/googleSheets.svg';
import slide from '../icons/prefilled/brands/googleSlides.svg';
import guru from '../icons/prefilled/brands/guru.svg';
import guruDark from '../icons/prefilled/brands/guruDark.svg';
import height from '../icons/prefilled/brands/height.svg';
import helpscout from '../icons/prefilled/brands/helpscout.svg';
import helpscoutDark from '../icons/prefilled/brands/helpscoutDark.svg';
import hubspot from '../icons/prefilled/brands/hubspot.svg';
import intercom from '../icons/prefilled/brands/intercom.svg';
import intercomDark from '../icons/prefilled/brands/intercomDark.svg';
import invision from '../icons/prefilled/brands/invision.svg';
import iorad from '../icons/prefilled/brands/iorad.svg';
import jira from '../icons/prefilled/brands/jira.svg';
import jotform from '../icons/prefilled/brands/jotform.svg';
import jsfiddle from '../icons/prefilled/brands/jsfiddle.svg';
import linear from '../icons/prefilled/brands/linear.svg';
import linearDark from '../icons/prefilled/brands/linearDark.svg';
import loom from '../icons/prefilled/brands/loom.svg';
import lucidchart from '../icons/prefilled/brands/lucidchart.svg';
import lucidchartDark from '../icons/prefilled/brands/lucidchartDark.svg';
import ludus from '../icons/prefilled/brands/ludus.svg';
import ludusDark from '../icons/prefilled/brands/ludusDark.svg';
import microsoft365 from '../icons/prefilled/brands/microsoft365.svg';
import microsoft from '../icons/prefilled/brands/microsoft.svg';
import excel from '../icons/prefilled/brands/microsoftExcel.svg';
import outlook from '../icons/prefilled/brands/microsoftOutlook.svg';
import powerpoint from '../icons/prefilled/brands/microsoftPowerpoint.svg';
import teams from '../icons/prefilled/brands/microsoftTeams.svg';
import word from '../icons/prefilled/brands/microsoftWord.svg';
import miro from '../icons/prefilled/brands/miro.svg';
import mode from '../icons/prefilled/brands/mode.svg';
import modeDark from '../icons/prefilled/brands/modeDark.svg';
import monday from '../icons/prefilled/brands/monday.svg';
import notion from '../icons/prefilled/brands/notion.svg';
import notionDark from '../icons/prefilled/brands/notionDark.svg';
import okta from '../icons/prefilled/brands/okta.svg';
import oktaDark from '../icons/prefilled/brands/oktaDark.svg';
import onelogin from '../icons/prefilled/brands/onelogin.svg';
import oneloginDark from '../icons/prefilled/brands/oneloginDark.svg';
import otter from '../icons/prefilled/brands/otter.svg';
import pingboard from '../icons/prefilled/brands/pingboard.svg';
import pingboardDark from '../icons/prefilled/brands/pingboardDark.svg';
import pitch from '../icons/prefilled/brands/pitch.svg';
import pitchDark from '../icons/prefilled/brands/pitchDark.svg';
import productboard from '../icons/prefilled/brands/productboard.svg';
import quip from '../icons/prefilled/brands/quip.svg';
import rows from '../icons/prefilled/brands/rows.svg';
import salesforce from '../icons/prefilled/brands/salesforce.svg';
import shortcut from '../icons/prefilled/brands/shortcut.svg';
import shortcutDark from '../icons/prefilled/brands/shortcutDark.svg';
import slabIcon from '../icons/prefilled/brands/slabIcon.svg';
import slack from '../icons/prefilled/brands/slack.svg';
import slideshare from '../icons/prefilled/brands/slideshare.svg';
import slideshareDark from '../icons/prefilled/brands/slideshareDark.svg';
import smartsheet from '../icons/prefilled/brands/smartsheet.svg';
import smartsheetDark from '../icons/prefilled/brands/smartsheetDark.svg';
import tableau from '../icons/prefilled/brands/tableau.svg';
import todoist from '../icons/prefilled/brands/todoist.svg';
import trello from '../icons/prefilled/brands/trello.svg';
import typeform from '../icons/prefilled/brands/typeform.svg';
import typeformDark from '../icons/prefilled/brands/typeformDark.svg';
import vimeo from '../icons/prefilled/brands/vimeo.svg';
import vimeoDark from '../icons/prefilled/brands/vimeoDark.svg';
import whimsical from '../icons/prefilled/brands/whimsical.svg';
import wistia from '../icons/prefilled/brands/wistia.svg';
import wistiaDark from '../icons/prefilled/brands/wistiaDark.svg';
import wrike from '../icons/prefilled/brands/wrike.svg';
import x from '../icons/prefilled/brands/x.svg';
import xDark from '../icons/prefilled/brands/xDark.svg';
import youtube from '../icons/prefilled/brands/youtube.svg';
import zendesk from '../icons/prefilled/brands/zendesk.svg';
import zendeskDark from '../icons/prefilled/brands/zendeskDark.svg';
import zendeskGuide from '../icons/prefilled/brands/zendeskGuide.svg';
import zendeskGuideDark from '../icons/prefilled/brands/zendeskGuideDark.svg';
import zendeskSupport from '../icons/prefilled/brands/zendeskSupport.svg';
import zendeskSupportDark from '../icons/prefilled/brands/zendeskSupportDark.svg';
import useIsDarkMode from '../utils/useIsDarkMode';
import * as styles from './ExternalBrandLogo.module.scss';
import SVGIcon from './SVGIcon';

type ProductImageDefinition = string | { light: string; dark: string };

// eslint-disable-next-line import/no-unused-modules -- expose for testing
export const PRODUCT_IMAGES = {
  api: { api: apiIcon },
  airtable: { airtable },
  asana: { asana },
  atlassian: { atlassian, confluence, jira },
  bamboohr: { bamboohr },
  box: { box },
  clickup: { clickup },
  shortcut: { shortcut: { light: shortcut, dark: shortcutDark } },
  drawio: { drawio },
  dropbox: { dropbox },
  figma: { figma },
  freshdesk: { freshdesk },
  github: { github: { light: github, dark: githubDark } },
  gitlab: { gitlab },
  gliffy: { gliffy: { light: gliffy, dark: gliffyDark } },
  gmail: { gmail },
  google: {
    google,
    calendar,
    doc,
    drawing,
    drive,
    form,
    map,
    sheet,
    slide,
    youtube,
  },
  guru: { guru: { light: guru, dark: guruDark } },
  height: { height },
  invision: { invision, v7: invision },
  iorad: { iorad },
  jotform: { jotform },
  linear: { linear: { light: linear, dark: linearDark } },
  loom: { loom },
  lucidchart: { lucidchart: { light: lucidchart, dark: lucidchartDark } },
  ludus: { ludus: { light: ludus, dark: ludusDark } },
  microsoft: { microsoft, excel, 365: microsoft365, powerpoint, teams, word },
  miro: { miro },
  mode: { mode: { light: mode, dark: modeDark } },
  monday: { monday },
  notion: { notion: { light: notion, dark: notionDark } },
  okta: { okta: { light: okta, dark: oktaDark } },
  onelogin: { onelogin: { light: onelogin, dark: oneloginDark } },
  outlook: { outlook },
  pingboard: { pingboard: { light: pingboard, dark: pingboardDark } },
  productboard: { productboard },
  quip: { quip },
  salesforce: { salesforce },
  slack: { slack },
  slab: { slab: slabIcon },
  slideshare: { slideshare: { light: slideshare, dark: slideshareDark } },
  todoist: { todoist },
  trello: { trello },
  vimeo: { vimeo: { light: vimeo, dark: vimeoDark } },
  wistia: { wistia: { light: wistia, dark: wistiaDark } },
  wrike: { wrike },
  zendesk: {
    zendesk: { light: zendesk, dark: zendeskDark },
    guide: { light: zendeskGuide, dark: zendeskGuideDark },
    support: { light: zendeskSupport, dark: zendeskSupportDark },
  },
  otter: { otter },
  typeform: { typeform: { light: typeform, dark: typeformDark } },
  canva: { canva },
  smartsheet: { smartsheet: { light: smartsheet, dark: smartsheetDark } },
  twitter: { twitter: { light: x, dark: xDark } },
  codepen: { codepen: { light: codepen, dark: codepenDark } },
  jsfiddle: { jsfiddle },
  hubspot: { hubspot },
  helpscout: { helpscout: { light: helpscout, dark: helpscoutDark } },
  intercom: { intercom: { light: intercom, dark: intercomDark } },
  whimsical: { whimsical },
  pitch: { pitch: { light: pitch, dark: pitchDark } },
  tableau: { tableau },
  rows: { rows },
  coda: { coda },
} as const satisfies {
  [brand: string]: Record<string, ProductImageDefinition>;
};

type BrandName = keyof typeof PRODUCT_IMAGES;

type ProductImages = {
  [K in BrandName]: { [I in K]: ProductImageDefinition } & Record<
    string,
    ProductImageDefinition
  >;
};

function getBrandImages<B extends BrandName>(brand: B): ProductImages[B] {
  return PRODUCT_IMAGES[brand];
}

export type BrandAndProductProps<B extends BrandName = BrandName> = B extends B
  ? {
      brand: B;
      product?: keyof ProductImages[B];
    }
  : never;

type UseExternalBrandLogoIconOptions<B extends BrandName> =
  BrandAndProductProps<B>;

export const useExternalBrandLogoIcon = <B extends BrandName>({
  product,
  brand,
}: UseExternalBrandLogoIconOptions<B>) => {
  const isDarkMode = useIsDarkMode();
  const productName = product ?? brand;

  const brandImages = getBrandImages(brand);
  const image = brandImages?.[productName] ?? brandImages?.[brand];

  let svgIcon: string | null = null;
  if (typeof image === 'string') {
    svgIcon = image;
  } else if (typeof image === 'object' && image) {
    svgIcon = isDarkMode ? image.dark : image.light;
  }

  return svgIcon;
};

type ExternalBrandLogoProps<B extends BrandName> = {
  height?: number;
  inline?: boolean;
} & UseExternalBrandLogoIconOptions<B>;

const ExternalBrandLogo = <B extends BrandName>(
  props: ExternalBrandLogoProps<B>,
) => {
  const svgIcon = useExternalBrandLogoIcon(props);
  if (!svgIcon) {
    return null;
  }

  return (
    <div
      aria-label={_.startCase(
        `${props.brand} ${props.product ? `${props.product} ` : ''}Logo`,
      )}
      role="img"
      className={props.inline ? styles.inline : undefined}
    >
      <SVGIcon inline={props.inline} size={props.height}>
        {svgIcon}
      </SVGIcon>
    </div>
  );
};

export default ExternalBrandLogo;
